export default {
  /** @param {import('vue').App} app */
  install (app) {
    app.config.globalProperties.$wasm ||= {}
  },
}
